import { Component, Input, ViewChild } from '@angular/core';
import { PlatformService } from '@panamax/app-state';
import { environment } from '../../../../environments/environment';
import { ProductClass } from '@usf/product-types';

@Component({
  selector: 'app-search-browse-carousel',
  templateUrl: './search-browse-carousel.component.html',
  styleUrls: ['./search-browse-carousel.component.scss'],
})
export class SearchBrowseCarouselComponent {
  @Input() displayGuestTitle = false;
  @Input() categories: ProductClass[];
  @ViewChild('browseSwiperRef') browseSwiperRef: any;
  baseCategoryImageUri = `${environment.mediaServerUrl}/`;
  browseCategoriesPath = 'categories';

  constructor(readonly platformService: PlatformService) {}

  // according to bug reports, swiper containers emit untrusted touch events that mess with touchmove navigation on some devices
  suppressUntrusted(ev: any) {
    if (!ev.isTrusted) {
      ev.stopPropagation();
    }
  }
}
